angular.module('wbServices')
.service 'Accounts', ['railsResource', ($resource) ->
    $resource '/investment_accounts/:id', { id: '@id' },
    getJoinableAccounts: { url: '/investment_accounts/get_joinable_accounts/:id', method: 'GET'}
]

.service 'AccountApplication', ['railsResource', ($resource) ->
  $resource '/account_applications/:id', { id: '@id', state: '@state' },
    statusMapping: { url: '/account_applications/status_mapping', method: 'GET' }
    agreementStatusMapping: { url: '/account_applications/agreement_status_mapping', method: 'GET' }
]

.service 'AccountApplicationV1', ['railsResource', ($resource) ->
  $resource '/v1/account_applications/:id', { id: '@id', state: '@state' },
    state: { method: 'PUT', url: '/v1/account_applications/:id/state/:state' }
    getComments: { method: 'GET', url: '/v1/account_applications/:id/comments', isArray: true }
    addComment: { method: 'POST', url: '/v1/account_applications/:id/comments' }
]

.service 'StaffAccountApplication', ['railsResource', ($resource) ->
  $resource '/staff/account_applications/:id', { id: '@id' },
    list: { method: 'GET', url: '/staff/account_applications/list' }
]

.service 'InvestmentAccount', ['railsResource', ($resource) ->
  $resource '/investment_accounts/:id', { id: '@id' },
    linkBankNumber: { method: 'POST',  url: '/investment_accounts/:id/link_bank_number' }
    delink: { method: 'POST', url: '/investment_accounts/:id/delink' }
    revertClosedInvestmentAccount: { method: 'POST', url: '/investment_accounts/:id/revert-account-closure'}
]

.service 'FinancialPlan', ['railsResource', ($resource) ->
  $resource '/financial_plans/:id', { id: '@id' }
]

.service 'Agreement', ['railsResource', ($resource) ->
  $resource '/agreements/:id', { id: '@id' }
]
.service 'Comment', ['railsResource', ($resource) ->
  $resource '/comments/:id', { id: '@id' }
]

.service 'Portfolios', ['railsResource', ($resource) ->
  $resource '/portfolios/:id', { id: '@id' }
]

.service 'PortfolioModels', ['railsResource', ($resource) ->
  $resource '/portfolio_models/:id', { id: '@id' }
]

.service 'Client', ['railsResource', ($resource) ->
  $resource '/clients/:id', { id: '@id' }
]

.service 'Profile', ['railsResource', ($resource) ->
  $resource '/profile', {}, {
    updateEmail: { url: '/profile/email', method: 'PUT' }
  }, {
    resourceException: false # because 403 from backend password check is handled by profile_controller.coffee
  }
]

.service 'Stats', ['railsResource', ($resource) ->
  $resource '/stats'
]

.service 'User', ['railsResource', ($resource) ->
  $resource '/users/:id', { id: '@id' }, {
    sendEmailConfirmation: { url: '/users/send_email_confirmation', method: 'POST' }
    disableTwoFactorAuth: { url: '/users/:id/disable_two_factor_auth', method: 'POST' }
    export: { url: '/users/:id/export_intercom_conversations', method: 'POST' }
    updatePreferences: { url: '/users/:id/update_preferences', method: 'PUT'}
  }
]

.service 'SendEbookOfferCodeEmail', ['railsResource', ($resource) ->
  $resource '/send_ebook_offer_code_email/:id', { id: '@id' }, {
    sendEbookOfferCodeEmail: { url: '/send_ebook_offer_code_email/:id/send_ebook_offer_code', method: 'POST' }
  }
]

.service 'PartnerChannel', ['railsResource', ($resource) ->
  $resource '/user_partner_channels/:id', { id: '@id', partner_channel: '@partner_channel' }, {
    setPartnerChannel: { method: 'PUT', url: '/user_partner_channels/:id?partner_channel=:partner_channel' }
    deletePartnerChannel: { method: 'DELETE', url: '/user_partner_channels/:id' }
  }
]

.service 'CurrentUserPartnerChannel', ['railsResource', ($resource) ->
  $resource '/get_partner_channel'
]

.service 'Kyc', ['railsResource', ($resource) ->
  $resource '/kycs', { id: '@id' }, {
    completePmReview: { method: 'POST', url: '/kycs/complete_pm_review?id=:id' }
  }
]

.service 'Spouse', ['railsResource', ($resource) ->
  $resource '/users/spouse'
]

.service 'Dashboard', ['railsResource', ($resource) ->
  $resource '/investment_accounts/dashboard'
]

.service 'Holding', ['railsResource', ($resource) ->
  $resource '/holdings/:id', { id: '@id' }
]

.service 'Transactions', ['railsResource', ($resource) ->
  $resource '/investment_accounts/:id/transactions', { id: '@id' }
]

.service 'Positions', ['railsResource', ($resource) ->
  $resource '/investment_accounts/:id/positions', { id: '@id' }
]

.service 'TransactionsDirect', ['railsResource', ($resource) ->
  $resource '/transactions/:id', { id: '@id' }
]

# We do not want the output "camelcased"
.service 'History', ['railsResource', ($resource) ->
  $resource '/investment_accounts/history', {}, { query: { method: 'GET', isArray: true, camelizeResponse: false }}
]

.service 'Report', ['railsResource', ($resource) ->
  $resource '/reports/:id', { id: '@id' }
]

.service 'Custodian', ['railsResource', ($resource) ->
  $resource '/custodians/:id', { id: '@id' }
]

.service 'Custodians', ['railsResource', ($resource) ->
  $resource '/custodians', {}
]

.service 'Holding', ['railsResource', ($resource) ->
  $resource '/holdings/:id', { id: '@id' }
]

.service 'FileAsset', ['railsResource', ($resource) ->
  $resource '/file_assets/:id', { id: '@id' }, {
    create: {
      method: 'POST',
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined }
    }
  }
]

.service 'FileAssetCategories', ['railsResource', ($resource) ->
  $resource '/file_asset_categories/:id', { id: '@id' }
]

.service 'Session', ['railsResource', ($resource) ->
  $resource '/sessions', null, null, { resourceException: false }
]

.service 'Password', ['railsResource', ($resource) ->
  $resource '/users/password', null, null, { resourceException: false }
]

.service 'TwoFactorAuth', ['railsResource', ($resource) ->
  $resource '/two_factor_auth', null, null, { resourceException: false },
    update: { method: 'PUT' }
]

.service 'AccountTypes', ['railsResource', ($resource) ->
  $resource '/account_types', { id: '@id' }
]

.service 'Subscription', ['railsResource', ($resource) ->
  $resource '/subscriptions/:id', { id: '@id' }
]

.service 'ClientProfileChanges', ['railsResource', ($resource) ->
  $resource '/client_profile_changes/:id', { id: '@id' },
    getComments: { method: 'GET', url: '/client_profile_changes/:id/comments', isArray: true }
    addComment: { method: 'POST', url: '/client_profile_changes/:id/comments' }
]

.service 'InvestmentAccountTransfersIn', ['railsResource', ($resource) ->
  $resource '/investment_account_transfers_in/:id', { id: '@id' },
]

.service 'Config', ['railsResource', ($resource) ->
  $resource '/config'
]

.service 'Transfer', ['railsResource', ($resource) ->
  $resource '/transfers/:id', { id: '@id' },
    getComments: { method: 'GET', url: '/transfers/:id/comments', isArray: true }
    addComment: { method: 'POST', url: '/transfers/:id/comments' }
    transactionMatches: { method: 'GET', url: '/transfers/:id/matching-transactions', isArray: true }
    updateStaffDetails: { method: 'POST', url: '/transfers/:id/update_staff_details' }
]

.service 'TransferStatus', ['railsResource', ($resource) ->
  $resource '/transfers/:id/update-status', { id: '@id' }
]

.service 'BankingInfo', ['railsResource', ($resource) ->
  $resource '/banking_info'
]

.service 'ProfileBankingInfo', ['railsResource', ($resource) ->
  $resource '/profile/banking_info', {},
    link: { method: 'POST', url: '/profile/banking_info/link' }
    cancelRequest: { method: 'DELETE', url: '/bank_request/cancel' }
]

.service 'ProfileAdvisorInfo', ['railsResource', ($resource) ->
  $resource '/profile/representative-info', {},
    updateShareInfo: { method: 'PUT', url: '/profile/representative-info/update_share_info' }
]

.service 'ProfileTaxInfo', ['railsResource', ($resource) ->
  $resource '/profile/tax_info'
]

.service 'ProfileEmailStatus', ['railsResource', ($resource) ->
  $resource '/email/status'
]

.service 'ProfileBeneficiaries', ['railsResource', ($resource) ->
  $resource '/beneficiary_designations', {},
    getState: { method: 'GET', url: '/beneficiary_designations', isArray: true }
]

.service 'Subscriptions', ['railsResource', ($resource) ->
  $resource '/subscriptions', {},
    updateSubscriptions: { method: 'PUT', url: '/subscriptions/user_subscriptions' }
]

.service 'ClientDetails', ['railsResource', ($resource) ->
  $resource '/client_details/:id', { id: '@id' },
    lockAccount: { method: 'GET', url: '/client_details/:id/lock_account' }
    unlockAccount: { method: 'GET', url: '/client_details/:id/unlock_account' }
]

.service 'StaffEFTRequests', ['railsResource', ($resource) ->
  $resource '/staff/eft_requests/:id', { id: '@id' }
]

.service 'EFTRequests', ['railsResource', ($resource) ->
  $resource '/eft_requests/:id', { id: '@id' }
]
